module.exports = __webpack_public_path__ + "img/mobile-legends.310d86c.png";